export default __webpack_public_path__ + "static/media/PasswordResetDone.cf273826.svg";